import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Backdrop = function (_Component) {
    inherits(Backdrop, _Component);

    function Backdrop() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Backdrop);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Backdrop.__proto__ || Object.getPrototypeOf(Backdrop)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            otherBackdropsAreOpen: document.body ? document.body.classList.contains('gd-backdrop__open') : false
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Backdrop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.state.otherBackdropsAreOpen && document.body) {
                document.body.classList.add('gd-backdrop__open');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (!this.state.otherBackdropsAreOpen && document.body) {
                document.body.classList.remove('gd-backdrop__open');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                inline = _props.inline,
                onClick = _props.onClick;

            var classNames = ['gd-backdrop'];

            if (inline) {
                classNames.push('gd-backdrop--inline');
            }

            return React.createElement(
                'div',
                { className: classNames.join(' '), onClick: onClick },
                children
            );
        }
    }]);
    return Backdrop;
}(Component);

function Icon(_ref) {
    var name = _ref.name,
        attributes = objectWithoutProperties(_ref, ['name']);

    return React.createElement('i', _extends({}, attributes, { className: 'gd-icon gd-icon-' + name }));
}

function Badge(_ref) {
    var children = _ref.children,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'default' : _ref$type,
        disabled = _ref.disabled,
        active = _ref.active,
        getRef = _ref.getRef,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        attributes = objectWithoutProperties(_ref, ['children', 'type', 'disabled', 'active', 'getRef', 'className']);

    var newClassNames = ['gd-badge', className];
    if (children.type === Icon) {
        newClassNames.push('gd-badge-icon');
    }
    if (type === 'primary') {
        newClassNames.push('gd-badge-primary');
    }
    if (disabled) {
        newClassNames.push('gd-disabled');
    }
    if (active && !disabled) {
        newClassNames.push('gd-active');
    }
    return React.createElement(
        'span',
        _extends({}, attributes, { className: newClassNames.join(' '), ref: getRef }),
        children
    );
}

function Button(_ref) {
    var children = _ref.children,
        disabled = _ref.disabled,
        getRef = _ref.getRef,
        id = _ref.id,
        name = _ref.name,
        onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onClick = _ref.onClick,
        onFocus = _ref.onFocus,
        onKeyDown = _ref.onKeyDown,
        onKeyPress = _ref.onKeyPress,
        onKeyUp = _ref.onKeyUp,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        onMouseOver = _ref.onMouseOver,
        tabIndex = _ref.tabIndex,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'discrete' : _ref$type,
        attributes = objectWithoutProperties(_ref, ['children', 'disabled', 'getRef', 'id', 'name', 'onBlur', 'onChange', 'onClick', 'onFocus', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onMouseEnter', 'onMouseLeave', 'onMouseOver', 'tabIndex', 'type']);

    var htmlType = type === 'submit' ? 'submit' : 'button';
    var className = 'gd-button gd-button-' + (type === 'submit' ? 'primary' : type);
    var kids = React.Children.map(children, function (child) {
        return child;
    });

    if (kids && kids.length === 1 && kids[0].type === Icon) {
        className += ' gd-button-icon';
    }

    return React.createElement(
        'button',
        _extends({}, attributes, {
            className: className,
            disabled: disabled,
            id: id,
            name: name,
            onBlur: onBlur,
            onChange: onChange,
            onClick: onClick,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onKeyPress: onKeyPress,
            onKeyUp: onKeyUp,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseOver: onMouseOver,
            tabIndex: tabIndex,
            ref: getRef,
            type: htmlType }),
        children
    );
}

function ButtonGroup(_ref) {
    var children = _ref.children,
        attributes = objectWithoutProperties(_ref, ['children']);

    return React.createElement(
        'div',
        _extends({}, attributes, { className: 'gd-button-group' }),
        children
    );
}

var Carousel = function (_Component) {
    inherits(Carousel, _Component);

    function Carousel() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Carousel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            active: 0
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Carousel, [{
        key: 'goToPrevious',
        value: function goToPrevious() {
            var children = this.props.children;

            this.setState(function (s) {
                return { active: s.active - 1 < 0 ? children.length - 1 : s.active - 1 };
            });
        }
    }, {
        key: 'goToNext',
        value: function goToNext() {
            var children = this.props.children;

            this.setState(function (s) {
                return { active: s.active + 1 < children.length ? s.active + 1 : 0 };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var children = this.props.children;
            var active = this.state.active;

            var hasButtons = children.length > 1;

            var slides = React.Children.map(children, function (child, index) {
                var className = 'gd-carousel-slide';
                if (index === active) {
                    className += ' gd-active';
                }
                return React.createElement(
                    'div',
                    { className: className },
                    child
                );
            });

            return React.createElement(
                'div',
                { className: 'gd-carousel' },
                hasButtons && React.createElement(
                    'span',
                    { className: 'gd-carousel-control gd-prev', onClick: function onClick() {
                            return _this2.goToPrevious();
                        } },
                    React.createElement('span', { className: 'gd-arrow gd-icon-arrow-left' })
                ),
                React.createElement(
                    'div',
                    { className: 'gd-carousel-slides' },
                    slides
                ),
                hasButtons && React.createElement(
                    'span',
                    { className: 'gd-carousel-control gd-next', onClick: function onClick() {
                            return _this2.goToNext();
                        } },
                    React.createElement('span', { className: 'gd-arrow gd-icon-arrow-right' })
                )
            );
        }
    }]);
    return Carousel;
}(Component);

var VIEWPORTS = ['xs', 'sm', 'md', 'lg'];

 // matches --fade-timer variable in stylesheets - 0.2s

/* eslint-disable react/no-unused-prop-types */
function getSizeClass(viewport, size) {
    if (typeof size === 'boolean' || size === 'auto') {
        return 'gd-col-' + viewport;
    }

    return 'gd-col-' + viewport + '-' + size;
}

function Column(_ref) {
    var children = _ref.children,
        first = _ref.first,
        last = _ref.last,
        props = objectWithoutProperties(_ref, ['children', 'first', 'last']);

    var classes = [];

    // sizing starts at xs (mobile first), so fallback if no xs size was specified
    if (!props.xs) {
        classes.push('gd-col-xs');
    }

    // allow setting first/last globally for all viewports
    if (first) {
        classes.push('gd-col-first');
    } else if (last) {
        classes.push('gd-col-last');
    }

    VIEWPORTS.forEach(function (viewport) {
        var viewportValue = props[viewport];

        if ((typeof viewportValue === 'undefined' ? 'undefined' : _typeof(viewportValue)) === 'object' && viewportValue.size) {
            classes.push(getSizeClass(viewport, viewportValue.size));

            if (typeof viewportValue.offset === 'number') {
                classes.push('gd-col-' + viewport + '-offset-' + viewportValue.offset);
            }

            if (viewportValue.first) {
                classes.push('gd-col-' + viewport + '-first');
            } else if (viewportValue.last) {
                classes.push('gd-col-' + viewport + '-last');
            }
        } else if (typeof viewportValue === 'boolean' || typeof viewportValue === 'string' || typeof viewportValue === 'number') {
            classes.push(getSizeClass(viewport, viewportValue));
        }
    });

    return React.createElement(
        'div',
        { className: classes.join(' ') },
        children
    );
}

function Container(_ref) {
    var children = _ref.children;

    return React.createElement(
        "div",
        { className: "gd-container" },
        children
    );
}

// first menu is always expanded by default
// if enough available height, the menu should be full height (show all children)
//      except when that exceeds the available height, then fill it (the available height) and scroll the available height (not the menu)
// if not enough available height then do not exceed max-height of menu (8 rows or something), scroll the menu if necessary
// if expanding a menu and others are also expanded, and this causes others to exceed the available height, collapse others
// if there are so many menus that when they are collapsed they exceed the available height, scroll the available height

var Menu = function (_Component) {
    inherits(Menu, _Component);

    function Menu() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Menu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpen: !!_this.props.open
        }, _this.renderTitle = function () {
            var _this$props = _this.props,
                fixed = _this$props.fixed,
                title = _this$props.title;


            if (title) {
                if (fixed) {
                    return React.createElement(
                        'h5',
                        null,
                        title
                    );
                }

                return React.createElement(
                    'h5',
                    { onClick: _this.toggle },
                    title,
                    React.createElement(Icon, { name: _this.state.isOpen ? 'arrow-up' : 'arrow-down' })
                );
            }

            return null;
        }, _this.toggle = function () {
            _this.setState({
                isOpen: !_this.state.isOpen
            }, function () {
                if (_this.props.onClick) {
                    _this.props.onClick(_this.state.isOpen);
                }
            });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Menu, [{
        key: 'componentWillReceiveProps',
        // used by the Navigation component to perform height calculations

        // refs
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.open !== nextProps.open) {
                this.setState({
                    isOpen: nextProps.open
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                fixed = _props.fixed,
                innerRef = _props.innerRef,
                onDragEnter = _props.onDragEnter,
                onDragLeave = _props.onDragLeave;
            var isOpen = this.state.isOpen;

            var classNames = ['gd-menu'];

            if (fixed || fixed === 'top') {
                classNames.push('gd-menu--fixed');
            }

            if (isOpen) {
                classNames.push('gd-menu--open');
            }

            return React.createElement(
                'section',
                {
                    className: classNames.join(' '),
                    onDragEnter: onDragEnter,
                    onDragLeave: onDragLeave,
                    ref: innerRef },
                this.renderTitle(),
                React.createElement(
                    'ul',
                    null,
                    children
                )
            );
        }
    }]);
    return Menu;
}(Component);

function MenuContent(_ref) {
    var children = _ref.children;

    return React.createElement(
        "li",
        { className: "gd-menu__content" },
        children
    );
}

/* eslint react/no-unused-prop-types: 0 */
var portal = window.top.document.getElementById('gd-portal');

if (!portal) {
    portal = document.createElement('div');
    portal.id = 'gd-portal';
    window.top.document.body.appendChild(portal);
}

function Portal(_ref) {
    var children = _ref.children;

    return ReactDOM.createPortal(children, portal);
}

var onKeyDownHandlers = [];

function onKeyDown(e) {
    var event = e;

    // when using both react and the native dom, some information is placed under e.detail and not e - fix that
    if (!event.keyCode && event.detail) {
        event.keyCode = event.detail.keyCode;
    }

    var i = onKeyDownHandlers.length;

    if (i > 0) {
        while (i--) {
            var keyHandler = onKeyDownHandlers[i];

            if (typeof keyHandler === 'function') {
                keyHandler(event);
            }

            if (event.defaultPrevented || !event.bubbles) {
                break;
            }
        }
    }
}

var KeyboardShortcutHandler = function (_PureComponent) {
    inherits(KeyboardShortcutHandler, _PureComponent);

    function KeyboardShortcutHandler() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, KeyboardShortcutHandler);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = KeyboardShortcutHandler.__proto__ || Object.getPrototypeOf(KeyboardShortcutHandler)).call.apply(_ref, [this].concat(args))), _this), _this.addEventListener = function () {
            onKeyDownHandlers.push(_this.props.onKeyDown);
            document.removeEventListener('keydown', onKeyDown);
            document.addEventListener('keydown', onKeyDown);
            document.addEventListener('unload', _this.removeEventListener);
        }, _this.removeEventListener = function () {
            var keyDownHandlersIndex = onKeyDownHandlers.indexOf(_this.props.onKeyDown);

            if (keyDownHandlersIndex > -1) {
                onKeyDownHandlers = onKeyDownHandlers.filter(function (f) {
                    return f !== _this.props.onKeyDown;
                });
            }
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(KeyboardShortcutHandler, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addEventListener();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeEventListener();
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);
    return KeyboardShortcutHandler;
}(PureComponent);

var keys = {
    down: 40,
    enter: 13,
    escape: 27,
    up: 38,
    tab: 9,
    a: 65,
    x: 88,
    c: 67,
    v: 86
};

var keycode = (function (keycode) {
    return keys[keycode];
});

var Modal = function (_Component) {
    inherits(Modal, _Component);

    function Modal() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Modal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (e) {
            if (e.keyCode === keycode('escape')) {
                e.preventDefault();
                _this.close(e);
            }
        }, _this.onClick = function (e) {
            // only close if the clicked target is where the event is bound
            if (e.currentTarget === e.target) {
                e.persist();
                _this.close(e);
            }
        }, _this.close = function (e) {
            var onClose = _this.props.onClose;


            _this.props.hide();

            if (typeof onClose === 'function') {
                onClose(e);
            }
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Modal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                visible = _props.visible,
                width = _props.width;


            if (!visible) {
                return null;
            }

            return React.createElement(
                Portal,
                null,
                React.createElement(
                    KeyboardShortcutHandler,
                    { onKeyDown: this.onKeyDown },
                    React.createElement(
                        Backdrop,
                        { onClick: this.onClick },
                        React.createElement(
                            'div',
                            { className: 'gd-modal', style: { width: width } },
                            React.createElement(
                                'div',
                                { className: 'gd-modal__close' },
                                React.createElement(
                                    Button,
                                    { onClick: function onClick(e) {
                                            return _this2.close(e);
                                        }, type: 'discrete' },
                                    React.createElement(Icon, { name: 'close' })
                                )
                            ),
                            typeof children === 'function' ? children({ closeModal: this.close }) : children
                        )
                    )
                )
            );
        }
    }]);
    return Modal;
}(Component);

var OverlayTrigger = function (_Component) {
    inherits(OverlayTrigger, _Component);

    function OverlayTrigger() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, OverlayTrigger);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = OverlayTrigger.__proto__ || Object.getPrototypeOf(OverlayTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOverlayVisible: false
        }, _this.createOverlay = function () {
            var _this$props = _this.props,
                align = _this$props.align,
                overlay = _this$props.overlay,
                position = _this$props.position;


            if (overlay.type === Modal) {
                return React.cloneElement(overlay, {
                    hide: _this.hideOverlay,
                    show: _this.showOverlay,
                    visible: _this.state.isOverlayVisible
                });
            }

            return React.cloneElement(overlay, {
                anchor: _this.anchor.children[0],
                hide: _this.hideOverlay,
                show: _this.showOverlay,
                visible: _this.state.isOverlayVisible,
                align: align,
                position: position
            });
        }, _this.toggleOverlay = function () {
            _this.setState(function (prevState) {
                return {
                    isOverlayVisible: !prevState.isOverlayVisible
                };
            }, function () {
                if (typeof _this.props.onToggle === 'function') {
                    _this.props.onToggle(_this.state.isOverlayVisible);
                }
            });
        }, _this.showOverlay = function () {
            _this.setState({
                isOverlayVisible: true
            }, function () {
                if (typeof _this.props.onShow === 'function') {
                    _this.props.onShow();
                }
            });
        }, _this.hideOverlay = function () {
            _this.setState({
                isOverlayVisible: false
            }, function () {
                if (typeof _this.props.onHide === 'function') {
                    _this.props.onHide();
                }
            });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(OverlayTrigger, [{
        key: 'render',


        // refs
        value: function render() {
            var _this2 = this;

            var children = this.props.children;


            return React.createElement(
                'span',
                { className: 'gd-overlay__anchor', ref: function ref(r) {
                        return _this2.anchor = r;
                    } },
                children && children({
                    hideOverlay: this.hideOverlay,
                    showOverlay: this.showOverlay,
                    toggleOverlay: this.toggleOverlay
                }),
                this.state.isOverlayVisible && this.createOverlay()
            );
        }
    }]);
    return OverlayTrigger;
}(Component);

var MenuLink = function (_Component) {
    inherits(MenuLink, _Component);

    function MenuLink() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, MenuLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MenuLink.__proto__ || Object.getPrototypeOf(MenuLink)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOverlayVisible: false,
            isDraggedOver: false
        }, _this.onClick = function (e) {
            var callback = _this.props.onClick;
            if (typeof callback === 'function') {
                e.preventDefault();
                callback(e);
            }
        }, _this.toggleOverlay = function () {
            return _this.setState(function (prevState) {
                return { isOverlayVisible: !prevState.isOverlayVisible };
            });
        }, _this.hideOverlay = function () {
            return _this.setState({ isOverlayVisible: false });
        }, _this.showOverlay = function () {
            return _this.setState({ isOverlayVisible: true });
        }, _this.onDragEnter = function (e) {
            e.preventDefault();

            _this.setState({ isDraggedOver: true });
        }, _this.onDragLeave = function (e) {
            e.preventDefault();

            if (e.target === e.currentTarget) {
                _this.setState({ isDraggedOver: false });
            }
        }, _this.onDrop = function (e) {
            e.preventDefault();
            e.persist();

            _this.setState({
                isDraggedOver: false
            }, function () {
                if (typeof _this.props.onDrop === 'function') {
                    _this.props.onDrop(e);
                }
            });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(MenuLink, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                active = _props.active,
                children = _props.children,
                disabled = _props.disabled,
                displayAsHeading = _props.displayAsHeading,
                extra = _props.extra,
                href = _props.href,
                onDrop = _props.onDrop,
                target = _props.target,
                title = _props.title,
                total = _props.total,
                popover = _props.popover;
            var _state = this.state,
                isDraggedOver = _state.isDraggedOver,
                isOverlayVisible = _state.isOverlayVisible;


            var canDrop = disabled !== true && typeof onDrop === 'function';
            var classNames = ['gd-menu__link'];

            if (active) {
                classNames.push('gd-menu__link--active');
            }

            if (disabled) {
                classNames.push('gd-menu__link--disabled');
            }

            if (displayAsHeading) {
                classNames.push('gd-menu__link--title');
            }

            if (isDraggedOver) {
                classNames.push('gd-menu__link--dragged-over');
            }

            var extraContent = void 0;

            if (extra) {
                extraContent = extra;
            } else if (popover) {
                extraContent = React.createElement(
                    OverlayTrigger,
                    {
                        onHide: this.hideOverlay,
                        onShow: this.showOverlay,
                        onToggle: this.toggleOverlay,
                        overlay: popover },
                    function (_ref2) {
                        var toggleOverlay = _ref2.toggleOverlay;
                        return React.createElement(
                            Button,
                            { onClick: toggleOverlay, type: 'discrete' },
                            React.createElement(Icon, { name: 'ellipsis' })
                        );
                    }
                );
                classNames.push('gd-menu__link--popover');

                if (isOverlayVisible) {
                    classNames.push('gd-menu__link--popover--open');
                }
            }

            var count = void 0;

            if (total !== undefined) {
                count = React.createElement(
                    'span',
                    { className: 'gd-menu__link__counter' },
                    total
                );
            }

            return React.createElement(
                'li',
                {
                    className: classNames.join(' '),
                    onDragEnter: canDrop ? this.onDragEnter : undefined,
                    onDragLeave: canDrop ? this.onDragLeave : undefined,
                    onDragOver: canDrop ? function (e) {
                        return e.preventDefault();
                    } : undefined,
                    onDrop: canDrop ? this.onDrop : undefined },
                React.createElement(
                    'a',
                    { href: href, onClick: !disabled ? this.onClick : undefined, target: target, title: title },
                    children
                ),
                (extraContent || isOverlayVisible || count) && React.createElement(
                    'span',
                    { className: 'gd-menu__link__extras' },
                    isOverlayVisible ? null : count,
                    extraContent
                )
            );
        }
    }]);
    return MenuLink;
}(Component);

function MenuPlaceholder() {
    var min = 55;
    var max = 95;
    var width = Math.floor(Math.random() * (max - min + 1)) + min + "%";

    return React.createElement(
        "li",
        { className: "gd-menu__link" },
        React.createElement("span", { className: "gd-menu__link__placeholder", style: { width: width } })
    );
}

function getOpenMenus(children) {
    var firstMenu = NaN;
    var openMenus = [];

    React.Children.toArray(children).forEach(function (child, i) {
        // do not include fixed menus
        if (!child.props.fixed) {
            // store the first menu, to be used if no menus are marked as open
            if (isNaN(firstMenu)) {
                firstMenu = i;
            }

            if (child.props.open) {
                openMenus.push(i);
            }
        }
    });

    return openMenus.length === 0 ? [firstMenu] : openMenus;
}

var Navigation = function (_Component) {
    inherits(Navigation, _Component);

    function Navigation() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Navigation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            height: NaN,
            openMenus: getOpenMenus(_this.props.children)
        }, _this.menus = [], _this.onMenuToggled = function (index) {
            var openMenus = [index];
            var nextTotalHeight = _this.menus.reduce(function (total, ref) {
                if (!ref) return total;

                return total + (ref.menu ? ref.menu.clientHeight : ref.clientHeight);
            }, 0);

            // if height of next open menus does not exceed available height, include currently open menus
            if (nextTotalHeight < _this.state.height) {
                openMenus = openMenus.concat(_this.state.openMenus);
            }

            _this.setState({ openMenus: openMenus });
        }, _this.calculateAvailableHeight = function () {
            // clear menu refs
            _this.menus = [];

            // update available height
            _this.setState({
                height: _this.navigation.clientHeight
            });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    // refs


    createClass(Navigation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.calculateAvailableHeight();
            window.addEventListener('resize', this.calculateAvailableHeight);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.children !== nextProps.children) {
                this.setState({
                    openMenus: getOpenMenus(nextProps.children)
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.calculateAvailableHeight);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var top = [];
            var main = [];
            var bottom = [];

            React.Children.toArray(this.props.children).forEach(function (child, i) {
                var clonedChild = React.cloneElement(child, {
                    key: i,
                    onClick: function onClick() {
                        return _this2.onMenuToggled(i);
                    },
                    open: _this2.state.openMenus.indexOf(i) > -1,
                    innerRef: function innerRef(r) {
                        return _this2.menus[i] = r;
                    }
                });

                if (clonedChild.props.fixed) {
                    if (clonedChild.props.fixed === 'bottom') {
                        bottom.push(clonedChild);
                    } else {
                        top.push(clonedChild);
                    }
                } else {
                    main.push(clonedChild);
                }
            });

            return React.createElement(
                'nav',
                { className: 'gd-navigation', ref: function ref(r) {
                        return _this2.navigation = r;
                    } },
                top.length > 0 && React.createElement(
                    'div',
                    { className: 'gd-navigation__top' },
                    top
                ),
                main.length > 0 && React.createElement(
                    'div',
                    { className: 'gd-navigation__main' },
                    main
                ),
                bottom.length > 0 && React.createElement(
                    'div',
                    { className: 'gd-navigation__bottom' },
                    bottom
                )
            );
        }
    }]);
    return Navigation;
}(Component);

/* eslint-disable react/no-unused-prop-types */
var Option = function (_ref) {
    var active = _ref.active,
        children = _ref.children,
        disabled = _ref.disabled,
        onClick = _ref.onClick;

    var className = 'gd-option';

    if (active) {
        className += ' gd-active';
    }

    if (disabled) {
        className += ' gd-disabled';
    }

    return React.createElement(
        'div',
        { className: className, onMouseDown: onClick, onClick: onClick },
        children
    );
};

var OPTION_HEIGHT = 35 * 0.75; // taken from stylesheet


function getChildren(props) {
    if (props.children) {
        return React.Children.toArray(props.children) || [];
    }

    return [];
}

function getActiveOptionIndex(props) {
    var activeOptionIndex = getChildren(props).findIndex(function (option) {
        return option.props.selected;
    });
    return activeOptionIndex > -1 ? activeOptionIndex : 0;
}

var Options = function (_Component) {
    inherits(Options, _Component);

    function Options() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Options);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Options.__proto__ || Object.getPrototypeOf(Options)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            activeOptionIndex: getActiveOptionIndex(_this.props)
        }, _this.selectOption = function (e, index) {
            var option = getChildren(_this.props)[index];
            var value = option.props.value !== null || option.props.value !== undefined ? option.props.value : option.props.children;

            if (option.props.disabled) {
                return;
            }

            if (e.persist) {
                e.persist();
            }

            // dirty hack around having no proper event to pass down handlers
            e.target.value = value; // eslint-disable-line no-param-reassign

            _this.setState({
                activeOptionIndex: index
            }, function () {
                return _this.props.onSelectOption(e, value);
            });
        }, _this.onKeyDown = function (e) {
            var activeOptionIndex = _this.state.activeOptionIndex;


            if (e.keyCode === keycode('enter') || e.keyCode === keycode('tab')) {
                if (e.keyCode === keycode('enter')) {
                    e.preventDefault();
                }

                if (e.persist) {
                    e.persist();
                }

                _this.list.childNodes[activeOptionIndex].click();
                return;
            }

            var children = getChildren(_this.props);
            var nextActiveOptionIndex = void 0;

            switch (e.keyCode) {
                case keycode('up'):
                    e.preventDefault();
                    nextActiveOptionIndex = _this.getNextActiveOptionIndex(activeOptionIndex, -1, children);
                    break;

                case keycode('down'):
                    e.preventDefault();
                    nextActiveOptionIndex = _this.getNextActiveOptionIndex(activeOptionIndex, 1, children);
                    break;

                default:
                    return;
            }

            if (nextActiveOptionIndex === children.length || nextActiveOptionIndex === -1) {
                return;
            }

            _this.setState({
                activeOptionIndex: nextActiveOptionIndex
            }, function () {
                return _this.scrollToActiveOption();
            });
        }, _this.scrollToActiveOption = function () {
            var visibleHeight = _this.calculateMaxHeight();
            var scrollTop = _this.list.scrollTop;
            var scrollBottom = scrollTop + visibleHeight;
            var currentOptionScrollBottom = (_this.state.activeOptionIndex + 1) * OPTION_HEIGHT;
            var currentOptionScrollTop = currentOptionScrollBottom - OPTION_HEIGHT;
            var currentOptionIsInViewPort = currentOptionScrollTop > scrollTop && currentOptionScrollBottom < scrollBottom;

            if (!currentOptionIsInViewPort) {
                if (currentOptionScrollTop < scrollTop) {
                    _this.list.scrollTop = currentOptionScrollTop;
                } else if (currentOptionScrollBottom > scrollBottom) {
                    _this.list.scrollTop = scrollTop + OPTION_HEIGHT;
                }
            }
        }, _this.getNextActiveOptionIndex = function (index, direction, children) {
            var nextIndex = index + direction;

            if (!children[nextIndex]) {
                return -1;
            }

            if (children[nextIndex].props.disabled) {
                return _this.getNextActiveOptionIndex(nextIndex, direction, children);
            }

            return nextIndex;
        }, _this.getStyleAttributes = function () {
            var maxHeight = _this.calculateMaxHeight();

            return {
                maxHeight: String(maxHeight) + 'px',
                minHeight: String(OPTION_HEIGHT) + 'px',
                width: _this.props.width
            };
        }, _this.calculateMaxHeight = function () {
            return OPTION_HEIGHT * 6;
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Options, [{
        key: 'componentWillReceiveProps',


        // refs
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                activeOptionIndex: getActiveOptionIndex(nextProps)
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return React.createElement(
                KeyboardShortcutHandler,
                { onKeyDown: this.onKeyDown },
                React.createElement(
                    'div',
                    {
                        className: 'gd-options',
                        ref: function ref(r) {
                            return _this2.list = r;
                        },
                        style: this.getStyleAttributes() },
                    React.Children.map(this.props.children, function (child, i) {
                        return React.cloneElement(child, {
                            active: _this2.state.activeOptionIndex === i,
                            disabled: _this2.props.disabled || child.props.disabled,
                            onClick: function onClick(e) {
                                return _this2.selectOption(e, i);
                            }
                        });
                    })
                )
            );
        }
    }]);
    return Options;
}(Component);

function Paper(_ref) {
    var ratio = _ref.ratio,
        children = _ref.children,
        highlightOnHover = _ref.highlightOnHover;

    var className = ['gd-paper'];
    var style = void 0;

    if (highlightOnHover) {
        className.push('gd-paper--highlight');
    }

    if (ratio) {
        className.push('gd-paper--proportional');
        style = {};

        switch (ratio) {
            case '16:9':
                style.paddingBottom = '56.25%';
                break;

            case '4:3':
                style.paddingBottom = '75%';
                break;

            case '3:2':
                style.paddingBottom = '66.66%';
                break;

            default:
                style.paddingBottom = '100%';
                break;
        }
    }

    return React.createElement(
        'div',
        { className: className.join(' '), style: style },
        children
    );
}

function Row(_ref) {
    var align = _ref.align,
        children = _ref.children,
        _ref$gutters = _ref.gutters,
        gutters = _ref$gutters === undefined ? true : _ref$gutters,
        justify = _ref.justify,
        reverse = _ref.reverse,
        props = objectWithoutProperties(_ref, ['align', 'children', 'gutters', 'justify', 'reverse']);

    var classes = ['gd-row'];

    // allow setting align globally for all viewports
    if (align) {
        classes.push('gd-row-align-' + align);
    }

    // allow setting justify globally for all viewports
    if (justify) {
        classes.push('gd-row-justify-' + justify);
    }

    // remove gutters between columns
    if (!gutters) {
        classes.push('gd-row-without-gutters');
    }

    if (reverse) {
        classes.push('gd-row-reverse');
    }

    VIEWPORTS.forEach(function (viewport) {
        var viewportValue = props[viewport];

        if ((typeof viewportValue === 'undefined' ? 'undefined' : _typeof(viewportValue)) === 'object') {
            if (viewportValue.align) {
                classes.push('gd-row-' + viewport + '-align-' + viewportValue.align);
            }

            if (viewportValue.justify) {
                classes.push('gd-row-' + viewport + '-justify-' + viewportValue.justify);
            }
        }
    });

    return React.createElement(
        'div',
        { className: classes.join(' ') },
        children
    );
}

var hasValue = function hasValue(value) {
    return value !== undefined || value !== null;
};

function getSelectedOptionValue(props) {
    if (props.children) {
        var selectedOption = React.Children.toArray(props.children).find(function (option) {
            return option.props.selected;
        });

        if (selectedOption) {
            return hasValue(selectedOption.props.value) ? selectedOption.props.value : selectedOption.props.children;
        }
    }

    return null;
}

var Select = function (_Component) {
    inherits(Select, _Component);

    function Select() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Select);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isHovered: false,
            isOpen: false,
            value: getSelectedOptionValue(_this.props)
        }, _this.getSelectedOption = function () {
            var value = _this.state.value;


            if (hasValue(value)) {
                return React.Children.map(_this.props.children, function (child) {
                    return {
                        text: child.props.children,
                        value: hasValue(child.props.value) ? child.props.value : child.props.children
                    };
                }).find(function (option) {
                    return option.value === value;
                });
            }

            return null;
        }, _this.open = function (event) {
            if (_this.props.disabled) {
                return;
            }
            event.persist();

            _this.setState({ isOpen: true }, function () {
                if (_this.props.onFocus) {
                    _this.props.onFocus(event);
                }
            });
        }, _this.close = function (event) {
            event.persist();

            _this.setState({ isHovered: false, isOpen: false }, function () {
                if (_this.props.onBlur) {
                    _this.props.onBlur(event);
                }
            });
        }, _this.createSelectOptionHandler = function (handler) {
            return function (e, value) {
                if (e.persist) {
                    e.persist();
                }

                if (typeof handler === 'function') {
                    handler(e);
                }

                _this.setState({
                    isOpen: false,
                    value: value
                });
            };
        }, _this.onKeyDown = function (e) {
            if (e.keyCode === keycode('escape')) {
                e.preventDefault();
                _this.close(e);
            }
        }, _this.onMouseEnter = function () {
            _this.setState({
                isHovered: true
            });
        }, _this.onMouseLeave = function () {
            _this.setState({
                isHovered: false
            });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Select, [{
        key: 'componentWillReceiveProps',


        // refs
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.children !== nextProps.children) {
                this.setState({
                    value: getSelectedOptionValue(nextProps)
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                disabled = _props.disabled,
                getRef = _props.getRef,
                highlighted = _props.highlighted,
                state = _props.state;
            var _state = this.state,
                isOpen = _state.isOpen,
                value = _state.value;

            var classNames = ['gd-select'];

            if (isOpen) {
                classNames.push('gd-active', 'gd-options-container');
            }

            if (!hasValue(value)) {
                classNames.push('gd-placeholder');
            }

            if (disabled) {
                classNames.push('gd-disabled');
            }

            if (highlighted) {
                classNames.push('gd-highlighted');
            }

            if (state) {
                classNames.push('gd-validation-' + state);
            }

            var selectedOption = this.getSelectedOption();

            return React.createElement(
                'div',
                {
                    className: classNames.join(' '),
                    onBlur: this.close,
                    onClick: this.open,
                    onFocus: this.open,
                    onKeyDown: this.onKeyDown,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    ref: getRef,
                    tabIndex: disabled ? -1 : 0 },
                React.createElement(
                    'div',
                    { className: 'gd-select__control' },
                    selectedOption ? selectedOption.text : this.props.placeholder,
                    React.createElement(Icon, { name: isOpen ? 'arrow-up' : 'arrow-down' })
                ),
                isOpen && React.createElement(
                    Options,
                    { disabled: disabled, onSelectOption: this.createSelectOptionHandler(this.props.onChange) },
                    React.Children.map(this.props.children, function (child) {
                        return React.cloneElement(child, {
                            selected: _this2.state.value === (hasValue(child.props.value) ? child.props.value : child.props.children)
                        });
                    })
                )
            );
        }
    }]);
    return Select;
}(Component);

var Spinner = function (_ref) {
    var attributes = objectWithoutProperties(_ref, []);

    return React.createElement("div", _extends({}, attributes, { className: "gd-spinner" }));
};

function Tab(_ref) {
    var children = _ref.children;

    return React.createElement(
        "div",
        { className: "gd-tabs__tab" },
        children
    );
}

function TabGroup(_ref) {
    var children = _ref.children;

    return children;
}

function findAncestor(element, className) {
    // polyfill for IE
    if (!document || !element) return null;

    if (!Element.prototype.matches) {
        // $FlowFixMe
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        // $FlowFixMe
        Element.prototype.closest = function (s) {
            var el = this;
            // $FlowFixMe
            if (!document.documentElement.contains(el)) return null;
            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    return element.closest(className);
}

function getOverlayCssTransform(align, anchor, position) {
    if (anchor) {
        var bounds = anchor.getBoundingClientRect();
        var arrowOffset = 16; // from css, arrow width * 2
        var height = anchor.offsetHeight;
        var heightCompensation = height / 2;
        var left = bounds.left;
        var top = bounds.top;
        var _width = anchor.offsetWidth;
        var widthCompensation = _width / 2;

        if (align) {
            if (align === 'left') {
                widthCompensation += 15;
            }

            if (align === 'right') {
                widthCompensation -= 15;
            }
        }

        switch (position) {
            case 'top':
                return {
                    left: left,
                    top: top,
                    transform: 'translate(-50%, -100%) translate(' + widthCompensation + 'px, -' + arrowOffset + 'px)'
                };

            case 'right':
                return {
                    left: left,
                    top: top,
                    transform: 'translate(' + _width + 'px, -50%) translate(' + arrowOffset + 'px, ' + heightCompensation + 'px)'
                };

            case 'left':
                return {
                    left: left,
                    top: top,
                    transform: 'translate(-100%, -50%) translate(-' + arrowOffset + 'px, ' + heightCompensation + 'px)'
                };

            default:
                return {
                    left: left,
                    top: top,
                    transform: 'translate(-50%, ' + height + 'px) translate(' + widthCompensation + 'px, ' + arrowOffset + 'px)'
                };
        }
    }

    return {};
}

var Overlay = function (_Component) {
    inherits(Overlay, _Component);

    function Overlay() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Overlay);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            transformStyle: getOverlayCssTransform(_this.props.align, _this.props.anchor, _this.props.position)
        }, _this.handleScroll = function () {
            _this.setState({
                transformStyle: getOverlayCssTransform(_this.props.align, _this.props.anchor, _this.props.position)
            });
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Overlay, [{
        key: 'componentDidMount',


        // refs
        value: function componentDidMount() {
            this.scroller = findAncestor(this.props.anchor, '.gd-backdrop');
            (this.scroller || window.top).addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (this.scroller || window.top).removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                align = _props.align,
                children = _props.children,
                className = _props.className,
                position = _props.position,
                width = _props.width;


            var style = _extends({}, this.state.transformStyle, {
                width: width
            });

            var alignClassName = align ? ' gd-overlay--' + position + '--align--' + align : '';

            return React.createElement(
                'span',
                { className: className + ' gd-overlay gd-overlay--' + position + alignClassName, style: style },
                children
            );
        }
    }]);
    return Overlay;
}(Component);

var ClickOutsideEnhancer = function (_React$Component) {
    inherits(ClickOutsideEnhancer, _React$Component);

    function ClickOutsideEnhancer() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, ClickOutsideEnhancer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ClickOutsideEnhancer.__proto__ || Object.getPrototypeOf(ClickOutsideEnhancer)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
            var _this$props = _this.props,
                exclusions = _this$props.exclusions,
                onClick = _this$props.onClick;


            if (typeof onClick === 'function' && _this.target) {
                if (Array.isArray(exclusions)) {
                    var containsOrIsExclusion = function containsOrIsExclusion(el, target) {
                        return el === target || el.contains(target);
                    };

                    if (exclusions.reduce(function (excluded, el) {
                        return containsOrIsExclusion(el, e.target) + excluded;
                    }, false)) {
                        return;
                    }
                }

                if (!_this.target.contains(e.target)) {
                    onClick(e);
                }
            }
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(ClickOutsideEnhancer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                if (_this2.props.onClick) {
                    window.top.addEventListener('click', _this2.onClick, true);
                }
            }, 100);
        }

        // refs

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.onClick) {
                window.top.removeEventListener('click', this.onClick, true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                children = _props.children,
                onClick = _props.onClick;


            if (typeof onClick !== 'function') {
                return children;
            }

            return React.createElement(
                'span',
                { className: 'gd-enhancer', ref: function ref(_ref2) {
                        return _this3.target = _ref2;
                    } },
                children
            );
        }
    }]);
    return ClickOutsideEnhancer;
}(React.Component);

var Popover = function (_ref) {
    var align = _ref.align,
        anchor = _ref.anchor,
        children = _ref.children,
        hide = _ref.hide,
        _ref$position = _ref.position,
        position = _ref$position === undefined ? 'bottom' : _ref$position,
        _ref$visible = _ref.visible,
        visible = _ref$visible === undefined ? false : _ref$visible,
        width = _ref.width;

    if (!visible) {
        return null;
    }

    var props = {
        align: align,
        anchor: anchor,
        position: position,
        width: width,
        className: 'gd-popover'
    };

    if (typeof close === 'function') {
        return React.createElement(
            ClickOutsideEnhancer,
            { exclusions: [anchor], onClick: hide },
            React.createElement(
                Overlay,
                props,
                typeof children === 'function' ? children({ closePopover: hide }) : children
            )
        );
    }

    return React.createElement(
        Overlay,
        props,
        children
    );
};

/* eslint-disable react/no-unused-prop-types */
function getActiveTab(children) {
    var activeTab = -1;

    React.Children.toArray(children).some(function (tab, i) {
        if (tab.props.active === true) {
            activeTab = i;
            return true;
        }
        return false;
    });

    return activeTab > -1 ? activeTab : 0;
}

function getFlattenedTabs(children) {
    var tabs = [];

    React.Children.forEach(children, function (child) {
        if (child.type === TabGroup) {
            tabs.push.apply(tabs, toConsumableArray(getFlattenedTabs(child.props.children)));
        } else {
            tabs.push(child);
        }
    });

    return tabs;
}

var Tabs = function (_Component) {
    inherits(Tabs, _Component);

    function Tabs() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Tabs);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            activeTab: getActiveTab(_this.props.children),
            tabs: getFlattenedTabs(_this.props.children)
        }, _this.renderArrowNavigation = function (tabs) {
            var activeTab = _this.state.activeTab;


            return React.createElement(
                ButtonGroup,
                null,
                React.createElement(
                    Button,
                    { disabled: activeTab === 0, onClick: _this.gotoPreviousTab, type: 'secondary' },
                    React.createElement(Icon, { name: 'arrow-left' })
                ),
                React.createElement(
                    Button,
                    { disabled: activeTab === tabs.length - 1, onClick: _this.gotoNextTab, type: 'secondary' },
                    React.createElement(Icon, { name: 'arrow-right' })
                )
            );
        }, _this.renderTabLink = function (tab, i) {
            var activeTab = _this.state.activeTab;

            var disabled = tab.props.disabled === true;
            var className = [];

            var content = void 0;

            if (tab.type === TabGroup) {
                var groupBaseIndex = _this.state.tabs.indexOf(tab.props.children[0]);
                var childTabs = React.Children.toArray(tab.props.children);
                var groupTitle = tab.props.title;

                childTabs.forEach(function (child, n) {
                    if (activeTab === groupBaseIndex + n) {
                        className.push('gd-tabs__list__active');
                        groupTitle = child.props.title;
                    }
                });

                content = React.createElement(
                    OverlayTrigger,
                    {
                        overlay: React.createElement(
                            Popover,
                            { position: 'bottom', visible: true, width: '150px' },
                            function (_ref2) {
                                var closePopover = _ref2.closePopover;
                                return React.createElement(
                                    Menu,
                                    null,
                                    childTabs.map(function (child, n) {
                                        return React.createElement(
                                            MenuLink,
                                            {
                                                disabled: child.props.disabled,
                                                onClick: function onClick() {
                                                    if (!child.props.disabled) {
                                                        _this.changeTab(groupBaseIndex + n);
                                                        closePopover();
                                                    }
                                                },
                                                key: child.props.title },
                                            child.props.title
                                        );
                                    })
                                );
                            }
                        ) },
                    function (_ref3) {
                        var toggleOverlay = _ref3.toggleOverlay;
                        return React.createElement(
                            'a',
                            { onClick: toggleOverlay },
                            groupTitle,
                            ' ',
                            React.createElement(Icon, { name: 'arrow-down' })
                        );
                    }
                );
            } else {
                var baseIndex = _this.state.tabs.indexOf(tab);

                if (_this.state.activeTab === baseIndex) {
                    className.push('gd-tabs__list__active');
                }

                if (disabled) {
                    className.push('gd-tabs__list__disabled');
                }

                content = React.createElement(
                    'a',
                    { onClick: function onClick() {
                            return !disabled && _this.changeTab(baseIndex);
                        } },
                    tab.props.title
                );
            }

            return React.createElement(
                'li',
                { className: className.join(' '), key: i },
                content
            );
        }, _this.changeTab = function (nextTab) {
            return _this.setState({ activeTab: nextTab });
        }, _this.gotoPreviousTab = function () {
            return _this.setState(function (state) {
                return { activeTab: _this.getPreviousTab(state.activeTab) };
            });
        }, _this.gotoNextTab = function () {
            return _this.setState(function (state) {
                return { activeTab: _this.getNextTab(state.activeTab) };
            });
        }, _this.getPreviousTab = function (activeTab) {
            var tabs = _this.state.tabs;

            var nextTabIndex = activeTab - 1;

            if (nextTabIndex < 0) {
                return activeTab;
            }

            var nextTab = tabs[nextTabIndex];

            if (nextTab.props.disabled === true) {
                return _this.getPreviousTab(nextTabIndex);
            }

            return nextTabIndex;
        }, _this.getNextTab = function (activeTab) {
            var tabs = _this.state.tabs;

            var nextTabIndex = activeTab + 1;

            if (nextTabIndex > tabs.length) {
                return activeTab;
            }

            var nextTab = tabs[nextTabIndex];

            if (nextTab.props.disabled === true) {
                return _this.getNextTab(nextTabIndex);
            }

            return nextTabIndex;
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Tabs, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                activeTab: getActiveTab(nextProps.children),
                tabs: getFlattenedTabs(nextProps.children)
            });
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (typeof nextProps.onChange === 'function') {
                nextProps.onChange(nextState.activeTab);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var showArrowNavigation = this.props.showArrowNavigation;
            var _state = this.state,
                activeTab = _state.activeTab,
                tabs = _state.tabs;


            return React.createElement(
                'div',
                { className: 'gd-tabs' },
                React.createElement(
                    'nav',
                    null,
                    showArrowNavigation && this.renderArrowNavigation(tabs),
                    React.createElement(
                        'ul',
                        { className: 'gd-tabs__list' },
                        React.Children.map(this.props.children, this.renderTabLink)
                    )
                ),
                tabs[activeTab].props.children
            );
        }
    }]);
    return Tabs;
}(Component);

var Tag = function (_ref) {
    var children = _ref.children,
        concise = _ref.concise,
        type = _ref.type,
        attributes = objectWithoutProperties(_ref, ['children', 'concise', 'type']);

    var className = 'gd-tag gd-tag-' + type;

    if (concise) {
        className += ' gd-tag-concise';
    }

    return React.createElement(
        'span',
        _extends({}, attributes, { className: className }),
        children
    );
};

function Checkbox(_ref) {
    var checked = _ref.checked,
        disabled = _ref.disabled,
        getRef = _ref.getRef,
        id = _ref.id,
        name = _ref.name,
        onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onKeyDown = _ref.onKeyDown,
        onKeyPress = _ref.onKeyPress,
        onKeyUp = _ref.onKeyUp,
        tabIndex = _ref.tabIndex;

    return React.createElement(
        "span",
        { className: "gd-checkbox" },
        React.createElement("input", {
            defaultChecked: checked,
            disabled: disabled,
            id: id,
            name: name,
            onBlur: onBlur,
            onChange: onChange,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onKeyPress: onKeyPress,
            onKeyUp: onKeyUp,
            tabIndex: tabIndex,
            type: "checkbox",
            ref: getRef }),
        React.createElement("span", null)
    );
}

function Form(_ref) {
    var children = _ref.children;

    return React.createElement(
        "div",
        { className: "gd-form" },
        children
    );
}

var createKeyDownShortcutHandler = function createKeyDownShortcutHandler(handler) {
    if (!handler) return undefined;

    var stopPropagationForKeyCombos = [keycode('a'), keycode('x'), keycode('c'), keycode('v')]; // CTRL combos

    return function (e) {
        if ((e.ctrlKey || e.metaKey || e.detail.ctrlKey || e.detail.metaKey) && stopPropagationForKeyCombos.indexOf(e.keyCode) > -1) {
            e.stopPropagation();
        }

        e.persist();

        if (typeof handler === 'function') {
            handler(e);
        }
    };
};

function Input(_ref) {
    var discrete = _ref.discrete,
        getRef = _ref.getRef,
        highlighted = _ref.highlighted,
        onKeyDown = _ref.onKeyDown,
        state = _ref.state,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        value = _ref.value,
        props = objectWithoutProperties(_ref, ['discrete', 'getRef', 'highlighted', 'onKeyDown', 'state', 'type', 'value']);

    var className = 'gd-input';

    if (state) {
        className += ' gd-validation-' + state;
    }

    if (discrete) {
        className += ' gd-input-discrete';
    }

    if (highlighted) {
        className += ' gd-input-highlighted';
    }

    return React.createElement('input', _extends({}, props, {
        className: className,
        onKeyDown: createKeyDownShortcutHandler(onKeyDown),
        type: type,
        ref: getRef,
        value: value || ''
    }));
}

var Input$1 = function (_ref2) {
    var button = _ref2.button,
        icon = _ref2.icon,
        prefix = _ref2.prefix,
        postfix = _ref2.postfix,
        props = objectWithoutProperties(_ref2, ['button', 'icon', 'prefix', 'postfix']);

    var input = void 0;
    var inputType = props.type;
    var inputButton = button;

    if (props.type === 'date') {
        inputType = 'text';
        inputButton = React.createElement(
            Button,
            { onClick: function onClick() {
                    return alert('TODO!');
                } },
            React.createElement(Icon, { name: 'calendar' })
        );
    }

    // create a container to position icon relative to input rather than input__group
    if (icon) {
        input = React.createElement(
            'span',
            { className: 'gd-input__icon__group' },
            React.createElement(Icon, { name: icon }),
            React.createElement(Input, _extends({}, props, { type: inputType }))
        );
    } else {
        input = React.createElement(Input, _extends({}, props, { type: inputType }));
    }

    // only wrap in an input__group if there are extras defined
    if (inputButton || prefix || postfix) {
        var classNames = ['gd-input__group'];

        if (inputButton) {
            classNames.push('gd-input__group--button');
        }

        if (prefix) {
            classNames.push('gd-input__group--prefix');
        }

        if (postfix) {
            classNames.push('gd-input__group--postfix');
        }

        return React.createElement(
            'span',
            { className: classNames.join(' ') },
            prefix && React.createElement(
                'span',
                { className: 'gd-input__group__prefix' },
                prefix
            ),
            input,
            postfix && React.createElement(
                'span',
                { className: 'gd-input__group__postfix' },
                postfix
            ),
            inputButton
        );
    }

    return input;
};

function Label(_ref) {
    var children = _ref.children,
        attributes = objectWithoutProperties(_ref, ["children"]);

    return React.createElement(
        "label",
        _extends({}, attributes, { className: "gd-label" }),
        children
    );
}

function getActiveIndexFromProps(props) {
    var activeIndex = React.Children.toArray(props.children).findIndex(function (option) {
        return option.props.selected;
    });
    return activeIndex > -1 ? activeIndex : 0;
}

var RadioGroup = function (_React$Component) {
    inherits(RadioGroup, _React$Component);

    function RadioGroup() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, RadioGroup);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            activeIndex: getActiveIndexFromProps(_this.props)
        }, _this.options = [], _this.renderOption = function (child, index) {
            var className = 'gd-radio-group__option';
            var disabled = _this.props.disabled || child.props.disabled;

            if (child.props.disabled) {
                className += ' gd-disabled';
            }

            return React.createElement(
                'label',
                { className: className, ref: function ref(_ref2) {
                        return _this.options[index] = _ref2;
                    }, tabIndex: -1 },
                React.createElement('input', {
                    checked: _this.state.activeIndex === index,
                    disabled: disabled,
                    name: _this.props.name,
                    onChange: disabled ? null : _this.onChange,
                    tabIndex: -1,
                    type: 'radio',
                    value: child.props.value || child.props.children }),
                ' ',
                child.props.children
            );
        }, _this.onChange = function (e) {
            e.persist();

            _this.setState({
                activeIndex: _this.getActiveIndexFromValue(e.target.value)
            }, function () {
                if (typeof _this.props.onChange === 'function') {
                    _this.props.onChange(e);
                }
            });
        }, _this.onKeyDown = function (e) {
            var activeIndex = _this.state.activeIndex;

            e.persist();

            if (e.keyCode === keycode('enter')) {
                e.preventDefault();
                _this.options[activeIndex].click();
                return;
            }

            var children = React.Children.toArray(_this.props.children);
            var nextActiveIndex = void 0;

            switch (e.keyCode) {
                case keycode('up'):
                    e.preventDefault();
                    nextActiveIndex = _this.getNextActiveIndex(activeIndex, -1, children);
                    break;

                case keycode('down'):
                    e.preventDefault();
                    nextActiveIndex = _this.getNextActiveIndex(activeIndex, 1, children);
                    break;

                default:
                    return;
            }

            if (nextActiveIndex === children.length || nextActiveIndex === -1) {
                return;
            }

            _this.setState({
                activeIndex: nextActiveIndex
            }, function () {
                _this.options[_this.state.activeIndex].click();

                if (typeof _this.props.onKeyDown === 'function') {
                    _this.props.onKeyDown(e);
                }
            });
        }, _this.getActiveIndexFromValue = function (value) {
            var activeIndex = React.Children.toArray(_this.props.children).findIndex(function (option) {
                return (option.props.value || option.props.children) === value;
            });
            return activeIndex > -1 ? activeIndex : 0;
        }, _this.getNextActiveIndex = function (index, direction, children) {
            var nextIndex = index + direction;

            if (!children[nextIndex]) {
                return -1;
            }

            if (children[nextIndex].props.disabled) {
                return _this.getNextActiveIndex(nextIndex, direction, children);
            }

            return nextIndex;
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    // refs


    createClass(RadioGroup, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                activeIndex: getActiveIndexFromProps(nextProps)
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var className = 'gd-radio-group';

            if (this.props.inline) {
                className += ' gd-inline';
            }

            if (this.props.disabled) {
                className += ' gd-disabled';
            }

            return React.createElement(
                'div',
                {
                    className: className,
                    id: this.props.id,
                    onBlur: this.props.onBlur,
                    onFocus: this.props.onFocus,
                    onKeyDown: this.onKeyDown,
                    onKeyPress: this.props.onKeyPress,
                    onKeyUp: this.props.onKeyUp,
                    ref: this.props.getRef,
                    tabIndex: this.props.disabled ? -1 : this.props.tabIndex || 0 },
                React.Children.map(this.props.children, this.renderOption)
            );
        }

        // computation

    }]);
    return RadioGroup;
}(React.Component);

var Textarea = function (_ref) {
    var children = _ref.children,
        disabled = _ref.disabled,
        getRef = _ref.getRef,
        id = _ref.id,
        name = _ref.name,
        onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onKeyDown = _ref.onKeyDown,
        onKeyPress = _ref.onKeyPress,
        onKeyUp = _ref.onKeyUp,
        placeholder = _ref.placeholder,
        tabIndex = _ref.tabIndex;

    return React.createElement('textarea', {
        className: 'gd-textarea',
        disabled: disabled,
        id: id,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onKeyDown: createKeyDownShortcutHandler(onKeyDown),
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        tabIndex: tabIndex,
        ref: getRef,
        value: children });
};

var Hint = function (_ref) {
    var children = _ref.children,
        state = _ref.state,
        title = _ref.title;

    var className = state ? 'gd-hint gd-hint-' + state : 'gd-hint';
    return React.createElement(
        'p',
        { className: className, title: title },
        children
    );
};

var ModalHeader = function (_ref) {
    var children = _ref.children;

    return React.createElement(
        "div",
        { className: "gd-modal__header" },
        children
    );
};

var ModalFooter = function (_ref) {
    var children = _ref.children;

    return React.createElement(
        "div",
        { className: "gd-modal__footer" },
        children
    );
};

var Tooltip = function (_ref) {
    var anchor = _ref.anchor,
        children = _ref.children,
        _ref$position = _ref.position,
        position = _ref$position === undefined ? 'bottom' : _ref$position,
        _ref$visible = _ref.visible,
        visible = _ref$visible === undefined ? false : _ref$visible,
        width = _ref.width;

    if (!visible) {
        return null;
    }

    return React.createElement(
        Overlay,
        {
            anchor: anchor,
            className: 'gd-tooltip',
            position: position,
            width: width },
        children
    );
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used to compose bitmasks for comparison styles. */
  var UNORDERED_COMPARE_FLAG = 1,
      PARTIAL_COMPARE_FLAG = 2;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      return freeProcess && freeProcess.binding('util');
    } catch (e) {}
  }();

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array ? array.length : 0,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return baseFindIndex(array, baseIsNaN, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  /**
   * Checks if a cache value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set$$1) {
    var index = -1,
        result = Array(set$$1.size);

    set$$1.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /** Built-in value references. */
  var _Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object),
      nativeMax = Math.max;

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = _Symbol ? _Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
        length = values ? values.length : 0;

    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }

  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    this.__data__ = new ListCache(entries);
  }

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
  }

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    return this.__data__['delete'](key);
  }

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
      var pairs = cache.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        return this;
      }
      cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];

    var length = result.length,
        skipIndexes = !!length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of methods like `_.difference` without support
   * for excluding multiple arrays or iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Array} values The values to exclude.
   * @param {Function} [iteratee] The iteratee invoked per element.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new array of filtered values.
   */
  function baseDifference(array, values, iteratee, comparator) {
    var index = -1,
        includes = arrayIncludes,
        isCommon = true,
        length = array.length,
        result = [],
        valuesLength = values.length;

    if (!length) {
      return result;
    }
    if (iteratee) {
      values = arrayMap(values, baseUnary(iteratee));
    }
    if (comparator) {
      includes = arrayIncludesWith;
      isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
      includes = cacheHas;
      isCommon = false;
      values = new SetCache(values);
    }
    outer: while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value) : value;

      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed, comparator)) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
        length = array.length;

    predicate || (predicate = isFlattenable);
    result || (result = []);

    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          // Recursively flatten arrays (susceptible to call stack limits).
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return index && index == length ? object : undefined;
  }

  /**
   * The base implementation of `getTag`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    return objectToString.call(value);
  }

  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {boolean} [bitmask] The bitmask of comparison flags.
   *  The bitmask may be composed of the following flags:
   *     1 - Unordered comparison
   *     2 - Partial comparison
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
  }

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = arrayTag,
        othTag = arrayTag;

    if (!objIsArr) {
      objTag = getTag(object);
      objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
      othTag = getTag(other);
      othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object),
        othIsObj = othTag == objectTag && !isHostObject(other),
        isSameTag = objTag == othTag;

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
  }

  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
  }

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
      return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }

  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }
    return function (object) {
      var objValue = get$$1(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
  }

  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = array;
      return apply(func, this, otherArgs);
    };
  }

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
  }

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1,
        result = true,
        seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache() : undefined;

    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            return seen.add(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= UNORDERED_COMPARE_FLAG;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        objProps = keys(object),
        objLength = objProps.length,
        othProps = keys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }

  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */
  function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];

      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11,
  // for data views in Edge < 14, and promises in Node.js.
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : undefined;

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }

  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */
  function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [path] : castPath(path);

    var result,
        index = -1,
        length = path.length;

    while (++index < length) {
      var key = toKey(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result) {
      return result;
    }
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
  }

  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */
  function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

    return value === proto;
  }

  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */
  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }

  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoize(function (string) {
    string = toString(string);

    var result = [];
    if (reLeadingDot.test(string)) {
      result.push('');
    }
    string.replace(rePropName, function (match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }

  /**
   * This method is like `_.difference` except that it accepts `iteratee` which
   * is invoked for each element of `array` and `values` to generate the criterion
   * by which they're compared. Result values are chosen from the first array.
   * The iteratee is invoked with one argument: (value).
   *
   * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {...Array} [values] The values to exclude.
   * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
   * @returns {Array} Returns the new array of filtered values.
   * @example
   *
   * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
   * // => [1.2]
   *
   * // The `_.property` iteratee shorthand.
   * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
   * // => [{ 'x': 2 }]
   */
  var differenceBy = baseRest(function (array, values) {
    var iteratee = last(values);
    if (isArrayLikeObject(iteratee)) {
      iteratee = undefined;
    }
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2)) : [];
  });

  /**
   * Gets the last element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the last element of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   */
  function last(array) {
    var length = array ? array.length : 0;
    return length ? array[length - 1] : undefined;
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function memoized() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  }

  // Assign cache to `_.memoize`.
  memoize.Cache = MapCache;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
  }

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get$$1(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */
  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }

  module.exports = differenceBy;
});

var createNotification = function (type, title, content) {
    var groupId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var onClose = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    return { id: Date.now(), content: content, groupId: groupId, title: title, type: type, onClose: onClose };
};

var CLOSE_AFTER_TIMEOUT = 3200;

var Notifications = function (_Component) {
    inherits(Notifications, _Component);

    function Notifications() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Notifications);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            notifications: _this.props.notifications ? [].concat(toConsumableArray(_this.props.notifications)) : []
        }, _this.timeouts = {}, _this.renderNotification = function (notification) {
            var autoHideNotification = notification.type === 'success';

            if (autoHideNotification && !_this.timeouts[notification.id]) {
                _this.timeouts[notification.id] = setTimeout(function () {
                    return _this.closeNotification(notification.id);
                }, CLOSE_AFTER_TIMEOUT);
            }

            var className = 'gd-notifications__notification gd-notifications__notification--' + notification.type;

            return React.createElement(
                'div',
                { className: className, key: notification.id },
                React.createElement(
                    'span',
                    { className: 'gd-notifications__notification__icon' },
                    _this.getStatusImage(notification.type)
                ),
                React.createElement(
                    'h2',
                    { className: 'gd-notifications__notification__title' },
                    notification.title
                ),
                React.createElement(
                    'div',
                    { className: 'gd-notifications__notification__content' },
                    notification.content
                ),
                React.createElement(
                    'button',
                    { className: 'gd-notifications__notification__close', onClick: function onClick() {
                            return _this.closeNotification(notification.id);
                        } },
                    React.createElement(Icon, { name: 'close' })
                )
            );
        }, _this.showNotification = function (type, title, content) {
            var groupId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var onClose = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            var notification = createNotification(type, title, content, groupId, onClose);

            _this.setState(function (prevState) {
                return {
                    notifications: [].concat(toConsumableArray(prevState.notifications), [notification])
                };
            });

            return notification.id;
        }, _this.closeNotification = function (id) {
            var notification = _this.state.notifications.find(function (n) {
                return n.id === id;
            });
            _this.setState(function (prevState) {
                return {
                    notifications: prevState.notifications.filter(function (n) {
                        return n.id !== id;
                    })
                };
            }, function () {
                if (_this.props.closeNotification) {
                    _this.props.closeNotification(id);
                }

                if (notification && typeof notification.onClose === 'function') {
                    notification.onClose();
                }
            });
        }, _this.clearPendingNotifications = function () {
            var pendingNotificationsWithGroupId = _this.state.notifications.filter(function (n) {
                return !!n.groupId && n.type === 'pending';
            });

            pendingNotificationsWithGroupId.forEach(function (notification) {
                if (_this.state.notifications.filter(function (n) {
                    return n.groupId === notification.groupId && n.type !== 'pending';
                }).length) {
                    _this.closeNotification(notification.id);
                }
            });
        }, _this.getNotifications = function () {
            return _this.state.notifications.sort(function (a, b) {
                return new Date(a.id) - new Date(b.id);
            });
        }, _this.getStatusImage = function (type) {
            switch (type) {
                case 'pending':
                    return React.createElement(Spinner, null);

                case 'information':
                    return React.createElement(Icon, { name: 'information' });

                case 'success':
                    return React.createElement(Icon, { name: 'tick' });

                case 'warning':
                    return React.createElement(Icon, { name: 'error' });

                case 'error':
                    return React.createElement(Icon, { name: 'error' });

                default:
                    return null;
            }
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    // statics


    createClass(Notifications, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                notifications: _extends({}, this.context.notifications, {
                    show: this.showNotification,
                    close: this.closeNotification
                })
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.notifications !== this.props.notifications && this.props.closeNotification) {
                this.setState(function (prevState) {
                    return {
                        notifications: [].concat(toConsumableArray(index(prevState.notifications, nextProps.notifications, 'id')), toConsumableArray(nextProps.notifications))
                    };
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.clearPendingNotifications();
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                React.Fragment,
                null,
                this.props.children,
                React.createElement(
                    'div',
                    { className: 'gd-notifications' },
                    this.getNotifications().map(this.renderNotification)
                )
            );
        }
    }]);
    return Notifications;
}(Component);

Notifications.childContextTypes = {
    notifications: function notifications() {
        return null;
    }
};

var withNotifications = function (WrappedComponent) {
    function withNotifications(props, context) {
        return React.createElement(WrappedComponent, _extends({}, props, context));
    }

    withNotifications.contextTypes = {
        notifications: function notifications() {
            return null;
        }
    };

    return withNotifications;
};

var InputAutoCompleteEnhancer = function (_React$Component) {
    inherits(InputAutoCompleteEnhancer, _React$Component);

    function InputAutoCompleteEnhancer(props) {
        classCallCheck(this, InputAutoCompleteEnhancer);

        var _this = possibleConstructorReturn(this, (InputAutoCompleteEnhancer.__proto__ || Object.getPrototypeOf(InputAutoCompleteEnhancer)).call(this, props));

        _this.createSelectOptionHandler = function (handler) {
            return function (e, value) {
                if (e.persist) {
                    e.persist();
                }

                if (typeof handler === 'function') {
                    handler(e);
                }

                _this.setState({
                    suggestions: [],
                    value: value
                });
            };
        };

        _this.createChangeHandler = function (handler) {
            var caseSensitive = _this.props.caseSensitive;


            return function (e) {
                e.persist();

                if (typeof handler === 'function') {
                    handler(e);
                }

                if (!e.isDefaultPrevented() && !e.isPropagationStopped()) {
                    var _value = _this.state.value;

                    var input = String(e.target.value);

                    if (String(_value) !== input) {
                        var _suggestions = [];

                        if (input && input.length) {
                            var casedInput = caseSensitive ? input : input.toLowerCase();
                            var caseComparator = function caseComparator(val) {
                                return caseSensitive ? String(val) : String(val).toLowerCase();
                            };

                            _suggestions = _this.props.data.filter(function (result) {
                                return caseComparator(result.text).includes(casedInput) || caseComparator(result.value).includes(casedInput);
                            });
                        }

                        _this.setState({
                            suggestions: _suggestions
                        });
                    }
                }
            };
        };

        _this.createKeyDownHandler = function (handler) {
            return function (e) {
                e.persist();

                if (e.keyCode === keycode('escape')) {
                    e.preventDefault();
                    _this.close();
                }

                if (typeof handler === 'function') {
                    handler(e);
                }
            };
        };

        _this.close = function () {
            return _this.setState({ suggestions: [] });
        };

        _this.state = {
            suggestions: [],
            value: null
        };
        return _this;
    }

    createClass(InputAutoCompleteEnhancer, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var width = this.props.width;
            var suggestions = this.state.suggestions;

            var child = React.Children.only(this.props.children);

            // extend the child input with our added functionality, and make sure to
            // pass along any handlers it already has, rather than overwrite them
            var inputElement = React.cloneElement(child, {
                onChange: this.createChangeHandler(child.props.onChange),
                onKeyDown: this.createKeyDownHandler(child.props.onKeyDown),
                getRef: function getRef(ref) {
                    return _this2.input = ref;
                }
            });

            return React.createElement(
                'div',
                { className: 'gd-options-container', style: { position: 'relative' } },
                inputElement,
                suggestions.length > 0 && React.createElement(
                    ClickOutsideEnhancer,
                    { exclusions: [this.input], onClick: this.close },
                    React.createElement(
                        Options,
                        { onSelectOption: this.createSelectOptionHandler(child.props.onChange), width: width },
                        suggestions.map(function (suggestion) {
                            return React.createElement(
                                Option,
                                { key: suggestion.value, value: suggestion.value },
                                suggestion.text
                            );
                        })
                    )
                )
            );
        }
    }]);
    return InputAutoCompleteEnhancer;
}(React.Component);

var ValidationEnhancer = function (_PureComponent) {
    inherits(ValidationEnhancer, _PureComponent);

    function ValidationEnhancer(props) {
        classCallCheck(this, ValidationEnhancer);

        var _this = possibleConstructorReturn(this, (ValidationEnhancer.__proto__ || Object.getPrototypeOf(ValidationEnhancer)).call(this, props));

        _this.createHandler = function (handler) {
            var _this$props = _this.props,
                onValidated = _this$props.onValidated,
                validator = _this$props.validator;


            if (typeof handler === 'function' && typeof validator === 'function') {
                return function (e) {
                    e.persist();

                    // trigger it immediately to allow state updates
                    handler(e);

                    var handle = function handle(isValid) {
                        if (typeof onValidated === 'function') {
                            onValidated(e, isValid);
                        }

                        _this.setState({
                            // ignore 'success' cases, so that the input doesn't remain in the success state
                            isValid: isValid === false ? false : null
                        });
                    };

                    if (e.target.value && e.target.value.length) {
                        Promise.resolve(validator(e.target.value)).then(handle).catch(handle);
                    }
                };
            }

            return handler;
        };

        _this.getValidationState = function () {
            switch (_this.state.isValid) {
                case true:
                    return 'success';

                case false:
                    return 'error';

                default:
                    return null;
            }
        };

        _this.state = {
            isValid: null
        };
        return _this;
    }

    createClass(ValidationEnhancer, [{
        key: 'render',
        value: function render() {
            var child = React.Children.only(this.props.children);

            return React.cloneElement(child, {
                onBlur: this.createHandler(child.props.onBlur),
                onChange: this.createHandler(child.props.onChange),
                onFocus: this.createHandler(child.props.onFocus),
                onKeyDown: this.createHandler(child.props.onKeyDown),
                onKeyPress: this.createHandler(child.props.onKeyPress),
                onKeyUp: this.createHandler(child.props.onKeyUp),
                state: this.getValidationState()
            });
        }
    }]);
    return ValidationEnhancer;
}(PureComponent);

export { Backdrop, Badge, Button, ButtonGroup, Carousel, Column, Container, Icon, Menu, MenuContent, MenuLink, MenuPlaceholder, Navigation, Option, Options, Paper, Row, Select, Spinner, Tab, TabGroup, Tabs, Tag, Checkbox, Form, Input$1 as Input, Label, RadioGroup, Textarea, Hint, Modal, ModalHeader, ModalFooter, OverlayTrigger, Popover, Tooltip, Notifications, createNotification, withNotifications, ClickOutsideEnhancer, KeyboardShortcutHandler as KeyboardShortcutEnhancer, InputAutoCompleteEnhancer, ValidationEnhancer as InputValidationEnhancer };
